/**
 * Severity of changing/removing a semantic-layer field, derived from its exact
 * blast radius across saved content. `breaking` means at least one chart,
 * dependent metric, or dashboard filter references the field and would break on
 * removal; `safe` means nothing references it.
 *
 * Note: this does NOT capture silent value-drift (same field id, changed SQL or
 * aggregation) — that requires comparing query results, not field references.
 */
export var FieldImpactSeverity;
(function (FieldImpactSeverity) {
    FieldImpactSeverity["Breaking"] = "breaking";
    FieldImpactSeverity["Safe"] = "safe";
})(FieldImpactSeverity || (FieldImpactSeverity = {}));
//# sourceMappingURL=fieldImpact.js.map